import { API_URLS } from '@helpers/api';
import SvgClipPaths from '@helpers/svgClipPaths';
import { withMotionMax } from '@hoc/withMotionMax';
import { withRedux } from '@hoc/withRedux';
import { useApi } from '@hooks/useApi';
import ESSLogo from '@img/ess-logo.svg';
import SvgAccount from '@img/icons/account.svg';
import SvgBasket from '@img/icons/basket.svg';
import SvgCloseMEP from '@img/icons/close-mep.svg';
import SvgClose from '@img/icons/close.svg';
import SvgContact from '@img/icons/contact.svg';
import SvgLocation from '@img/icons/location.svg';
import SvgMenuMEP from '@img/icons/menu-mep.svg';
import SvgMenu from '@img/icons/menu.svg';
import SvgPhone from '@img/icons/phone.svg';
import SvgSearch from '@img/icons/search.svg';
import MEPLogo from '@img/mep-logo-30.svg';
import MEPLogoMobile from '@img/mep-logo-mob-30.svg';
import { basket } from '@redux/slices/basket';
import { retrieveBasket } from '@redux/slices/basket/actions/retrieveBasket';
import { useAppDispatch, useAppSelector } from '@redux/store';
import CartOverlay from '@stories/Widgets/Global/Header/CartOverlay/CartOverlay';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useForm } from 'react-hook-form';
import DesktopNavigation from './DesktopNavigation/DesktopNavigation';
import S from './Header.styles';
import MobileNavigation from './MobileNavigation/MobileNavigation';
import SearchTypeahead from './SearchTypeahead/SearchTypeahead';
const Header = (props) => {
    const dispatch = useAppDispatch();
    const basketState = useAppSelector((state) => state.basket);
    const { handleSubmit, register, formState: { errors }, watch, } = useForm();
    const { handleSubmit: handleSubmitMobile, register: registerMobile, formState: { errors: errorsMobile }, watch: watchMobile, } = useForm();
    const onSubmit = (data) => (window.location.href = `${props.searchUrl}?search=${encodeURIComponent(data.search)}`);
    const [isScrollActive, setIsScrollActive] = React.useState(false);
    const [isScrollPartial, setIsScrollPartial] = React.useState(false);
    const [isMenuActive, setIsMenuActive] = React.useState(false);
    const [isDrawerActive, setIsDrawerActive] = React.useState(false);
    const [isTypeaheadActive, setIsTypeaheadActive] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState('');
    /* Navigation states, must be able to be reset by closing nav */
    const [activeLink, setActiveLink] = React.useState('');
    const [activeTwo, setActiveTwo] = React.useState('');
    const [activeThree, setActiveThree] = React.useState('');
    const CloseSvg = props.site === 'mep' ? SvgCloseMEP : SvgClose;
    const MenuSvg = props.site === 'mep' ? SvgMenuMEP : SvgMenu;
    const typeahead = useApi({
        url: `${API_URLS.getTypeahead}?term=${encodeURI(searchTerm)}`,
        validate: () => searchTerm.length > 1,
    });
    const { search } = watch();
    const { search: searchMobile } = watchMobile();
    React.useEffect(() => {
        if (typeahead.status === 'complete' && typeahead.data) {
            setIsTypeaheadActive(true);
        }
        else if (!typeahead.data) {
            setIsTypeaheadActive(false);
        }
    }, [typeahead.status, typeahead.data]);
    React.useEffect(() => {
        if (!isTypeaheadActive) {
            typeahead.clear();
            setSearchTerm('');
        }
    }, [isTypeaheadActive]);
    React.useEffect(() => {
        if (search?.length > 1 && search !== searchTerm && !searchTerm.includes(search)) {
            setSearchTerm(search);
        }
        else if (search?.length < 2) {
            setIsTypeaheadActive(false);
        }
    }, [search]);
    React.useEffect(() => {
        if (searchMobile?.length > 1 && searchMobile !== searchTerm) {
            setSearchTerm(searchMobile);
        }
    }, [searchMobile]);
    React.useEffect(() => {
        setIsTypeaheadActive(false);
    }, [activeLink, isMenuActive]);
    React.useEffect(() => {
        loadBasket();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(() => {
        const handleScroll = (initial) => {
            if (window.scrollY >= 400) {
                if (initial) {
                    setIsScrollPartial(true);
                    setTimeout(() => setIsScrollActive(true), 500);
                }
                else {
                    setIsScrollActive(true);
                }
            }
            else if (window.scrollY > 230) {
                setIsScrollPartial(true);
            }
            else {
                setIsScrollPartial(false);
                setIsScrollActive(false);
                setIsMenuActive(false);
                setActiveLink('');
                setActiveTwo('');
                setActiveThree('');
                setIsTypeaheadActive(false);
            }
        };
        handleScroll(true);
        window.addEventListener('scroll', () => handleScroll(false));
        return () => {
            window.removeEventListener('scroll', () => handleScroll(false));
        };
    }, []);
    React.useEffect(() => {
        if (basketState.drawer === 'closed') {
            setTimeout(() => setIsDrawerActive(false), 1100);
        }
        else {
            setIsDrawerActive(true);
        }
    }, [basketState.drawer]);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(SvgClipPaths, { site: props.site ?? 'ess' }),
        React.createElement(S.Wrapper, null,
            React.createElement(S.Container, { "data-site": props.site, "data-scroll-active": isScrollActive, "data-scroll-partial": isScrollPartial, "data-has-phone": !!props.phoneNumber, "data-drawer-open": isDrawerActive },
                React.createElement(S.TopWrapper, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Logo, { href: "/", "aria-label": "Go to Homepage" },
                            React.createElement(S.LogoImg, null, props.site === 'mep' ? (React.createElement(React.Fragment, null,
                                React.createElement(MEPLogoMobile, null),
                                React.createElement(MEPLogo, null))) : (React.createElement(ESSLogo, null))))),
                    React.createElement(S.TopContainer, null,
                        React.createElement(S.QuickLinks, null, props.quickLinks.map((ql) => (React.createElement("li", { key: ql.id },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.QuickLink, { href: ql.url, target: ql.target }, ql.text)))))),
                        React.createElement(S.FlexBreak, null),
                        React.createElement(S.SearchForm, { onSubmit: handleSubmit(onSubmit), "aria-label": "Desktop search" },
                            React.createElement(S.SearchInput, { type: "text", placeholder: props.searchPlaceholder, ...register('search', { required: 'Please enter a search term' }) }),
                            errors.search && React.createElement(S.SearchError, null, errors.search.message),
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.SearchSubmit, { "aria-label": "Submit Search" },
                                    React.createElement(SvgSearch, null)))),
                        React.createElement(S.CtaLinks, null,
                            props.ctaLinks.length > 0 &&
                                props.ctaLinks.map((cta) => (React.createElement(S.CtaLinkItem, { key: cta.id },
                                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                        React.createElement(S.CtaLink, { href: cta.url, target: cta.target },
                                            React.createElement(S.CtaLinkIcon, null, getQuickLinkIcon(cta.icon)),
                                            cta.text))))),
                            React.createElement(S.CtaLinkItem, null,
                                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                    React.createElement(S.CtaLink, { as: "button", onClick: openBasket },
                                        React.createElement(S.CtaLinkIcon, null,
                                            React.createElement(SvgBasket, null),
                                            React.createElement(S.BasketCount, null, basketState.totalQuantity ?? props.basketCount)),
                                        "My ",
                                        props.basketOverlay.name))),
                            React.createElement(S.CtaLinkItem, null,
                                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                    React.createElement(S.CtaLink, { as: "button", onClick: () => {
                                            setIsMenuActive(!isMenuActive);
                                            setActiveLink('');
                                            setActiveTwo('');
                                            setActiveThree('');
                                        }, "aria-label": `${isMenuActive ? 'Close Navigation' : 'Open Navigation'}` },
                                        React.createElement(S.CtaLinkIcon, { "data-active": isMenuActive }, isMenuActive ? React.createElement(CloseSvg, null) : React.createElement(MenuSvg, null)))))))),
                React.createElement(S.NavigationPlaceholder, null),
                React.createElement(S.NavigationWrapper, { "data-visible": isMenuActive },
                    React.createElement(DesktopNavigation, { activeLink: activeLink, activeThree: activeThree, activeTwo: activeTwo, links: props.navigationLinks, searchOpen: isTypeaheadActive, setActiveLink: setActiveLink, setActiveThree: setActiveThree, setActiveTwo: setActiveTwo, site: props.site }),
                    props.phoneNumber && (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.PhoneLink, { href: `tel:${props.phoneNumber.url}`, target: props.phoneNumber.target },
                            React.createElement(SvgPhone, null),
                            React.createElement("span", null, props.phoneNumber.text))))),
                React.createElement(S.SearchForm, { onSubmit: handleSubmitMobile(onSubmit), "aria-label": "Mobile search" },
                    React.createElement(S.SearchInner, null,
                        React.createElement(S.SearchInput, { type: "text", placeholder: props.searchPlaceholder, ...registerMobile('search', { required: 'Please enter a search term' }) }),
                        errorsMobile.search && React.createElement(S.SearchError, null, errorsMobile.search.message),
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.SearchSubmit, { "aria-label": "Submit Search" },
                                React.createElement(SvgSearch, null))))),
                React.createElement(S.StickyWrapper, null,
                    React.createElement(S.StickyButtons, null,
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.CtaLink, { as: "button", onClick: openBasket, "aria-label": `${props.basketCount} items in basket` },
                                React.createElement(S.CtaLinkIcon, null,
                                    React.createElement(SvgBasket, null),
                                    React.createElement(S.BasketCount, null, basketState.totalQuantity ?? props.basketCount)))),
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.CtaLink, { as: "button", onClick: () => {
                                    setIsMenuActive(!isMenuActive);
                                    setActiveLink('');
                                    setActiveTwo('');
                                    setActiveThree('');
                                }, "aria-label": `${isMenuActive ? 'Close Navigation' : 'Open Navigation'}` },
                                React.createElement(S.CtaLinkIcon, { "data-active": isMenuActive }, isMenuActive ? React.createElement(CloseSvg, null) : React.createElement(MenuSvg, null)))))),
                React.createElement(MobileNavigation, { active: isMenuActive, activeLink: activeLink, activeThree: activeThree, activeTwo: activeTwo, cta: props.mobileCta, links: props.navigationLinks, setActiveLink: setActiveLink, setActiveThree: setActiveThree, setActiveTwo: setActiveTwo, site: props.site }),
                React.createElement(SearchTypeahead, { active: isTypeaheadActive, data: typeahead.data, labels: props.typeaheadLabels, status: typeahead.status, site: props.site, onClose: () => setIsTypeaheadActive(false), loggedIn: props.isLoggedIn }),
                React.createElement(CartOverlay, { ...props.basketOverlay, site: props.site })))));
    async function loadBasket() {
        dispatch(retrieveBasket());
    }
    async function openBasket() {
        dispatch(basket.actions.setDrawerStatus('open'));
    }
};
export function getQuickLinkIcon(name) {
    switch (name) {
        case 'account':
            return React.createElement(SvgAccount, null);
        case 'contact':
            return React.createElement(SvgContact, null);
        case 'location':
            return React.createElement(SvgLocation, null);
    }
}
export default withRedux(withMotionMax(Header));
